export default __webpack_public_path__ + "static/media/school-kid.de5a27dd.png";